export default __webpack_public_path__ + "static/media/lomepal_club.213b4a41.png";